module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("7BIdz"))).then(() => parcelRequire('8ReIo'));